import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import VueBasicAlert from "vue-basic-alert";
import {provide, ref, watch} from "vue";
import {useRoute} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const alert = ref();
provide('alert',alert);

const isDashboard = ref(false);
const route = useRoute();
watch(route, (curr,old) => {
    isDashboard.value = !!curr.meta.dashboard;
},{ immediate: true });


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createElementVNode("main", {
      class: _normalizeClass(["md:pb-16", {'dashboard' : isDashboard.value}])
    }, [
      _createVNode(_unref(VueBasicAlert), {
        ref_key: "alert",
        ref: alert,
        closeIn: 5000
      }, null, 512),
      _createVNode(_component_router_view)
    ], 2),
    _createVNode(AppFooter)
  ], 64))
}
}

})